/* ==========================================================================
   Desktop Sticky Cart — Login + OTP + Signup (parallel build).

   Pixel-faithful replica of the cart page's #loginPopup_desktop / #otpPopup_desktop
   (snippets/newAddPage.liquid), with its own #StickyCartLogin markup
   (snippets/sticky-cart-login.liquid) + `stl__` classes so it coexists with the cart
   page's modal on /cart. Reuses the SAME global OTPService
   (snippets/login-api-config.liquid) + endpoints, so behaviour matches exactly:
     • phone OR WhatsApp → sendOTPToPhone(phone, method) → OTP screen (60s resend timer)
     • verify → returning user: window.location = multipass_url (logs in + reloads)
                new user: signup screen → updateCustomer → multipass_url
     • Login via WhatsApp toggles the OTP delivery method (SMS ⇄ WhatsApp)
   Exposes window.StickyCartLogin.open() / close() / isLoggedIn(). Desktop only.
   ========================================================================== */
(function () {
  'use strict';

  var root, phoneInput, clearBtn, getOtpBtn, getOtpText, getOtpIcon,
      waRow, waText, waImg, waRowOtp, waTextOtp, waImgOtp, otpWaIcon,
      otpInputs, verifyBtn, timerEl, resendRow, resendBtn, editBtn, phoneDisp,
      firstEl, lastEl, emailEl, signupBtn;
  var otpId = null, phone = '', method = 'phone', timer = null, secs = 60;
  var PHONE_RE = /^[6-9]\d{9}$/;

  // Button icons (SMS / WhatsApp) — swapped by setMethod().
  var SMS_BTN_ICON = '<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#stlb_sms)"><path d="M15.5 1.50098H3.5C2.675 1.50098 2 2.17598 2 3.00098V16.1388C2 16.2725 2.16157 16.3394 2.25607 16.2449L4.95607 13.5449C4.9842 13.5168 5.02235 13.501 5.06213 13.501H15.5C16.325 13.501 17 12.826 17 12.001V3.00098C17 2.17598 16.325 1.50098 15.5 1.50098ZM15.5 11.851C15.5 11.9338 15.4328 12.001 15.35 12.001H4.43963C4.39985 12.001 4.3617 12.0168 4.33357 12.0449L3.75607 12.6224C3.66157 12.7169 3.5 12.65 3.5 12.5163V3.15098C3.5 3.06813 3.56716 3.00098 3.65 3.00098H15.35C15.4328 3.00098 15.5 3.06813 15.5 3.15098V11.851Z" fill="white"/></g><defs><clipPath id="stlb_sms"><rect width="18" height="18" fill="white" transform="translate(0.5)"/></clipPath></defs></svg>';
  var WA_BTN_ICON = '<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.69821 6.02083C8.53188 5.57852 8.33977 5.61009 8.21188 5.60524C8.08388 5.60052 7.97181 5.60286 7.79888 5.60567C7.65255 5.60805 7.41286 5.64575 7.20388 5.85618C6.99462 6.06626 6.40833 6.57149 6.36778 7.64231C6.32751 8.71294 7.07403 9.7768 7.17829 9.92571C7.28247 10.0752 8.60384 12.3959 10.8001 13.3503C12.9966 14.3045 13.0081 14.0136 13.4111 13.9923C13.8144 13.9712 14.7285 13.514 14.9306 13.0129C15.1326 12.5118 15.1488 12.0762 15.0974 11.9833C15.046 11.8907 14.9021 11.8305 14.6868 11.7138C14.4714 11.5968 13.4136 11.0302 13.2152 10.9501C13.0168 10.8702 12.872 10.8287 12.7175 11.0411C12.5629 11.2529 12.1241 11.7274 11.9911 11.8679C11.8575 12.0086 11.729 12.0216 11.5135 11.9043C11.2987 11.7875 10.6005 11.5313 9.79095 10.7591C9.16102 10.1583 8.74755 9.42927 8.6277 9.20688C8.50782 8.98434 8.62692 8.87079 8.74099 8.76669C8.84325 8.67266 8.96977 8.52056 9.08442 8.39759C9.19845 8.27462 9.23868 8.18548 9.31727 8.04278C9.39567 7.9004 9.36415 7.772 9.31329 7.6611C9.26239 7.55024 8.86446 6.46313 8.69821 6.02083Z" fill="white"/><path d="M10.6587 2.5C12.6215 2.5 14.4664 3.25789 15.8533 4.63406C17.2376 6.00766 18 7.83332 18 9.77469C18 11.7159 17.2376 13.5415 15.8533 14.9152C14.4663 16.2914 12.6214 17.0494 10.6587 17.0494C9.41625 17.0494 8.18836 16.736 7.10766 16.1431L6.63824 15.8856L6.12797 16.0477L3.7275 16.8102L4.48434 14.5779L4.67176 14.0251L4.3682 13.5265C3.68098 12.3977 3.31773 11.1003 3.31773 9.77469C3.31773 7.83332 4.08016 6.00766 5.46449 4.63402C6.85141 3.25789 8.69605 2.5 10.6587 2.5ZM10.6587 1.25C5.91426 1.25 2.06773 5.06645 2.06773 9.77469C2.06773 11.3852 2.5182 12.8915 3.30051 14.1765L1.75 18.75L6.50641 17.239C7.73719 17.9142 9.1527 18.2994 10.6587 18.2994C15.4037 18.2994 19.25 14.4824 19.25 9.77469C19.25 5.06645 15.4037 1.25 10.6587 1.25Z" fill="white"/></svg>';
  var WA_IMG = '<img src="https://cdn.shopify.com/s/files/1/0565/8021/0861/files/image_43.png?v=1756758782" alt="" width="22" height="22">';
  var SMS_IMG = '<img src="https://cdn.shopify.com/s/files/1/0565/8021/0861/files/sms.png?v=1756813445" alt="" width="22" height="22">';

  function svc() {
    if (typeof OTPService !== 'undefined') return new OTPService();
    if (window.OTPService) return new window.OTPService();
    return null;
  }

  function isLoggedIn() {
    var s = document.querySelector('[data-sticky-cart]');
    return !!(s && s.getAttribute('data-logged-in') === 'true');
  }

  /* ---- screens / open / close ----------------------------------------- */
  function showScreen(name) {
    var screens = root.querySelectorAll('[data-stl-screen]');
    for (var i = 0; i < screens.length; i++) {
      screens[i].hidden = screens[i].getAttribute('data-stl-screen') !== name;
    }
  }

  function open() {
    if (!root) return;
    resetLogin();
    setMethod('phone'); // always start on SMS
    showScreen('login');
    root.hidden = false;
    void root.offsetWidth;
    root.classList.add('is-open');
    document.addEventListener('keydown', onKey);
    if (phoneInput) phoneInput.focus();
  }

  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    document.removeEventListener('keydown', onKey);
    stopTimer();
    setTimeout(function () { root.hidden = true; }, 300);
  }

  function onKey(e) { if (e.key === 'Escape' || e.key === 'Esc') close(); }

  /* ---- helpers --------------------------------------------------------- */
  function showErr(sel, msg) {
    var el = root.querySelector(sel);
    if (el) { el.innerHTML = msg; el.hidden = false; }
  }
  function clearErr(sel) {
    var el = root.querySelector(sel);
    if (el) el.hidden = true;
  }
  function loading(btn, text) {
    if (!btn) return;
    btn.dataset.label = btn.dataset.label || btn.textContent;
    btn.textContent = text;
    btn.disabled = true;
  }
  function unloading(btn) {
    if (!btn) return;
    btn.textContent = btn.dataset.label || btn.textContent;
    btn.disabled = false;
  }

  // Get-OTP button has an icon + text span, so it needs its own loading handling.
  function getOtpLoading(on) {
    if (!getOtpBtn) return;
    if (on) {
      getOtpBtn.disabled = true;
      if (getOtpText) getOtpText.textContent = 'Sending OTP…';
      if (getOtpIcon) getOtpIcon.style.display = 'none';
    } else {
      if (getOtpIcon) getOtpIcon.style.display = '';
      setMethod(method); // restores icon + label for the current method
      if (getOtpBtn) getOtpBtn.disabled = !PHONE_RE.test((phoneInput && phoneInput.value) || '');
    }
  }

  // Switch OTP delivery method (SMS ⇄ WhatsApp): updates the button + both WA rows.
  function setMethod(m) {
    method = m;
    var wa = m === 'whatsapp';
    if (getOtpText) getOtpText.textContent = wa ? 'Get OTP via WhatsApp' : 'Get OTP via SMS';
    if (getOtpIcon) getOtpIcon.innerHTML = wa ? WA_BTN_ICON : SMS_BTN_ICON;
    [[waText, waImg], [waTextOtp, waImgOtp]].forEach(function (pair) {
      if (pair[0]) {
        pair[0].textContent = wa ? 'Login via SMS' : 'Login via WhatsApp';
        pair[0].style.color = wa ? '#000000' : '#118968';
      }
      if (pair[1]) pair[1].innerHTML = wa ? SMS_IMG : WA_IMG;
    });
  }

  function resetLogin() {
    if (phoneInput) phoneInput.value = '';
    if (clearBtn) clearBtn.style.display = 'none';
    if (getOtpBtn) getOtpBtn.disabled = true;
    clearErr('[data-stl-login-err]');
  }
  function resetOtp() {
    for (var i = 0; i < otpInputs.length; i++) otpInputs[i].value = '';
    if (verifyBtn) { verifyBtn.disabled = true; verifyBtn.textContent = 'Verify OTP'; }
    clearErr('[data-stl-otp-err]');
  }
  function otpValue() {
    var v = '';
    for (var i = 0; i < otpInputs.length; i++) v += (otpInputs[i].value || '');
    return v;
  }

  function startTimer() {
    secs = 60;
    if (resendBtn) resendBtn.hidden = true;
    if (resendRow) resendRow.style.display = '';
    tick();
    timer = setInterval(tick, 1000);
    function tick() {
      if (timerEl) timerEl.textContent = secs + 's';
      if (secs <= 0) {
        stopTimer();
        if (resendRow) resendRow.style.display = 'none';
        if (resendBtn) resendBtn.hidden = false;
        return;
      }
      secs--;
    }
  }
  function stopTimer() { if (timer) { clearInterval(timer); timer = null; } }

  /* ---- send OTP -------------------------------------------------------- */
  function sendOtp() {
    var val = (phoneInput.value || '').trim();
    clearErr('[data-stl-login-err]');
    if (!PHONE_RE.test(val)) { showErr('[data-stl-login-err]', 'Please enter a valid 10-digit mobile number.'); return; }
    var s = svc();
    if (!s) { window.location.href = '/account/login'; return; }
    phone = val;
    getOtpLoading(true);
    if (typeof gtag !== 'undefined') { try { gtag('event', 'request_otp', { source: 'Sticky Cart', otpsource: method }); } catch (e) {} }
    s.sendOTPToPhone(phone, method).then(function (result) {
      getOtpLoading(false);
      if (result && result.success) {
        otpId = result.data && result.data.data && result.data.data.otpId;
        window.currentOtpId = otpId; window.currentPhoneNumber = phone;
        if (phoneDisp) phoneDisp.textContent = '+91' + phone;
        // Show a WhatsApp glyph next to the number + reword "Edit" when on WhatsApp.
        if (otpWaIcon) {
          if (method === 'whatsapp') { otpWaIcon.innerHTML = WA_IMG; otpWaIcon.style.display = 'flex'; }
          else { otpWaIcon.innerHTML = ''; otpWaIcon.style.display = 'none'; }
        }
        if (editBtn) editBtn.textContent = method === 'whatsapp' ? 'Edit whatsapp number' : 'Edit phone number';
        showScreen('otp');
        resetOtp();
        startTimer();
        if (otpInputs[0]) otpInputs[0].focus();
      } else {
        showErr('[data-stl-login-err]', otpErrorMsg(result));
      }
    }).catch(function () {
      getOtpLoading(false);
      showErr('[data-stl-login-err]', 'Something went wrong. Please try again.');
    });
  }

  function otpErrorMsg(result) {
    var c = result && result.statusCode;
    if (c == 10029) return 'Invalid phone number. Please check and try again.';
    if (c == 10011 || c == 10015) return 'Too many attempts. Please try again later.';
    if (c == 10046) return 'OTP limit exceeded. Please try again later.';
    return (result && result.message) || 'Failed to send OTP. Please try again.';
  }

  function resendOtp() {
    var s = svc(); if (!s) return;
    clearErr('[data-stl-otp-err]');
    s.resendUserOTP(phone, method).then(function (result) {
      if (result && result.success) {
        otpId = (result.data && result.data.data && result.data.data.otpId) || otpId;
        window.currentOtpId = otpId;
        resetOtp();
        startTimer();
      } else {
        showErr('[data-stl-otp-err]', otpErrorMsg(result));
      }
    }).catch(function () {});
  }

  /* ---- verify OTP ------------------------------------------------------ */
  function verifyOtp() {
    var otp = otpValue();
    if (otp.length !== 6) return;
    var s = svc(); if (!s) { window.location.href = '/account/login'; return; }
    clearErr('[data-stl-otp-err]');
    loading(verifyBtn, 'Verifying…');
    s.verifyUserOTP('+91' + phone, otp, otpId, method, window.location.href).then(function (result) {
      if (result && result.success && result.data) {
        if (result.data.multipass_url) {
          // Returning user → log in + reload (returns to this page).
          if (typeof gtag !== 'undefined') { try { gtag('event', 'login', { source: 'Sticky Cart', otpsource: method }); } catch (e) {} }
          window.isPaymentRedirecting = true;
          window.location.href = result.data.multipass_url;
          return;
        }
        // New user → signup.
        window.verifiedOtpId = otpId;
        var sp = root.querySelector('[data-stl-signup-phone]');
        if (sp) sp.value = '+91-' + phone;
        unloading(verifyBtn);
        showScreen('signup');
        return;
      }
      unloading(verifyBtn);
      showErr('[data-stl-otp-err]', (result && result.message) || 'Incorrect OTP. Please try again.');
    }).catch(function () {
      unloading(verifyBtn);
      showErr('[data-stl-otp-err]', 'An error occurred. Please try again.');
    });
  }

  /* ---- signup (new user) ---------------------------------------------- */
  function signupValid() {
    var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((emailEl.value || '').trim());
    return (firstEl.value || '').trim() && (lastEl.value || '').trim() && emailOk;
  }
  function refreshSignupBtn() { if (signupBtn) signupBtn.disabled = !signupValid(); }

  function submitSignup() {
    if (!signupValid()) return;
    var s = svc(); if (!s) return;
    clearErr('[data-stl-signup-err]');
    loading(signupBtn, 'Submitting…');
    s.updateCustomer({
      first_name: firstEl.value.trim(),
      last_name: lastEl.value.trim(),
      email: emailEl.value.trim(),
      phone_no: '+91' + phone,
      otp_id: window.verifiedOtpId || otpId,
      accept_email_marketing: true,
      accept_sms_marketing: true,
      accept_whatsapp_marketing: true,
      checkout_url: window.location.href
    }).then(function (res) {
      if (res && res.success && res.data && res.data.data && res.data.data.multipass_url) {
        if (typeof gtag !== 'undefined') { try { gtag('event', 'sign_up', { source: 'Sticky Cart' }); } catch (e) {} }
        window.isPaymentRedirecting = true;
        window.location.href = res.data.data.multipass_url;
        return;
      }
      unloading(signupBtn);
      showErr('[data-stl-signup-err]', (res && res.message) || 'Failed to create your account. Please try again.');
    }).catch(function () {
      unloading(signupBtn);
      showErr('[data-stl-signup-err]', 'Something went wrong. Please try again.');
    });
  }

  /* ---- WhatsApp toggle / guest ---------------------------------------- */
  function toggleMethod() { setMethod(method === 'whatsapp' ? 'phone' : 'whatsapp'); }

  // From the OTP screen the toggle also returns to the phone screen (parity with the
  // cart page), clearing the entered OTP + timer so the user re-requests via the new method.
  function toggleMethodFromOtp() {
    toggleMethod();
    stopTimer();
    resetOtp();
    showScreen('login');
    if (phoneInput) phoneInput.focus();
  }

  /* ---- wire-up --------------------------------------------------------- */
  function init() {
    root = document.getElementById('StickyCartLogin');
    if (!root) return;
    phoneInput = root.querySelector('[data-stl-phone]');
    clearBtn = root.querySelector('[data-stl-clear]');
    getOtpBtn = root.querySelector('[data-stl-get-otp]');
    getOtpText = root.querySelector('[data-stl-get-otp-text]');
    getOtpIcon = root.querySelector('[data-stl-get-otp-icon]');
    waRow = root.querySelector('[data-stl-wa]');
    waText = root.querySelector('[data-stl-wa-text]');
    waImg = root.querySelector('[data-stl-wa-img]');
    waRowOtp = root.querySelector('[data-stl-wa-otp]');
    waTextOtp = root.querySelector('[data-stl-wa-text-otp]');
    waImgOtp = root.querySelector('[data-stl-wa-img-otp]');
    otpWaIcon = root.querySelector('[data-stl-otp-wa-icon]');
    otpInputs = root.querySelectorAll('.stl__otp-input');
    verifyBtn = root.querySelector('[data-stl-verify]');
    timerEl = root.querySelector('[data-stl-timer]');
    resendRow = root.querySelector('.stl__resend-row');
    resendBtn = root.querySelector('[data-stl-resend]');
    editBtn = root.querySelector('[data-stl-edit]');
    phoneDisp = root.querySelector('[data-stl-phone-disp]');
    firstEl = root.querySelector('[data-stl-first]');
    lastEl = root.querySelector('[data-stl-last]');
    emailEl = root.querySelector('[data-stl-email]');
    signupBtn = root.querySelector('[data-stl-signup-submit]');

    var closers = root.querySelectorAll('[data-stl-close]');
    for (var i = 0; i < closers.length; i++) closers[i].addEventListener('click', close);

    if (phoneInput) {
      phoneInput.addEventListener('input', function () {
        phoneInput.value = phoneInput.value.replace(/\D/g, '').slice(0, 10);
        if (clearBtn) clearBtn.style.display = phoneInput.value ? 'flex' : 'none';
        if (getOtpBtn) getOtpBtn.disabled = !PHONE_RE.test(phoneInput.value);
      });
      phoneInput.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !getOtpBtn.disabled) sendOtp(); });
    }
    if (clearBtn) clearBtn.addEventListener('click', function () {
      if (phoneInput) { phoneInput.value = ''; phoneInput.focus(); }
      clearBtn.style.display = 'none';
      if (getOtpBtn) getOtpBtn.disabled = true;
    });
    if (getOtpBtn) getOtpBtn.addEventListener('click', sendOtp);

    for (var j = 0; j < otpInputs.length; j++) {
      (function (idx) {
        var inp = otpInputs[idx];
        inp.addEventListener('input', function () {
          inp.value = inp.value.replace(/\D/g, '').slice(0, 1);
          if (inp.value && idx < otpInputs.length - 1) otpInputs[idx + 1].focus();
          if (verifyBtn) verifyBtn.disabled = otpValue().length !== 6;
        });
        inp.addEventListener('keydown', function (e) {
          if (e.key === 'Backspace' && !inp.value && idx > 0) otpInputs[idx - 1].focus();
          if (e.key === 'Enter' && otpValue().length === 6) verifyOtp();
        });
        inp.addEventListener('paste', function (e) {
          var t = (e.clipboardData || window.clipboardData).getData('text').replace(/\D/g, '').slice(0, 6);
          if (!t) return;
          e.preventDefault();
          for (var k = 0; k < t.length && k < otpInputs.length; k++) otpInputs[k].value = t[k];
          if (verifyBtn) verifyBtn.disabled = otpValue().length !== 6;
          (otpInputs[Math.min(t.length, otpInputs.length - 1)] || inp).focus();
        });
      })(j);
    }
    if (verifyBtn) verifyBtn.addEventListener('click', verifyOtp);
    if (resendBtn) resendBtn.addEventListener('click', resendOtp);
    if (editBtn) editBtn.addEventListener('click', function () { stopTimer(); showScreen('login'); if (phoneInput) phoneInput.focus(); });

    if (waRow) waRow.addEventListener('click', toggleMethod);
    if (waRowOtp) waRowOtp.addEventListener('click', toggleMethodFromOtp);

    [firstEl, lastEl, emailEl].forEach(function (el) { if (el) el.addEventListener('input', refreshSignupBtn); });
    if (signupBtn) signupBtn.addEventListener('click', submitSignup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.StickyCartLogin = { open: open, close: close, isLoggedIn: isLoggedIn };
})();
